export default {
  data() {
    return {
      isShowForm: true,
      isShowLink: true
    };
  },
  methods: {
    beforeLeave() {
      this.isShowLink = false;
    },
    afterEnter() {
      this.isShowLink = true;
    },
    searchInputFocus() {
      this.isShowForm = false;
    },
    searchInputBlur() {
      this.isShowForm = true;
    }
  }
};
